import React from "react";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Card } from "react-bootstrap";
import SVG from "react-inlinesvg";
import NumberFormat from "react-number-format";

export function TransactionCounter({ counterList, fundCounterList }) {
  const {
    total_transactions = "0",
    total_transactions_with_sc = "0",
    total_accepted_request = "0",
    total_rejected_request = "0",
    ACH = "0",
    // eCheck = "0",
    // Wire_Transfer = "0",
    Credit_Card = "0",
    Debit_Card = "0",
  } = counterList || {};

  const {
    // Total_eCheck_commission = "0",
    Total_ACH_commission = "0",
    Total_Creditcard_commission = "0",
    // Total_wiretransfer_commission = "0",
    Total_Debitcard_commission = "0",
  } = fundCounterList || {};

  const amountFormatter = (amount) => {
    return (
      <NumberFormat
        value={amount}
        displayType="text"
        thousandSeparator={true}
        prefix="$"
        decimalSeparator="."
        decimalScale={2}
        fixedDecimalScale={true}
      />
    );
  };

  return (
    <>
      <div className="history-wrapper container dashboard-statistics">
        <div className="row">
          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/total-transactions.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(total_transactions)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      Total Transactions
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>

          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/sc.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(total_transactions_with_sc)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      Total Transactions with SC
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-4x svg-icon-warning menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/made-funds.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(total_accepted_request)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      Total Accepted Funds
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/payment-rejected-requests.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(total_rejected_request)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      Total Rejected Funds
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
      <div className="history-wrapper container">
        <div className="row">
          <div className="col-md-12">
            <div className="dashboard-header d-md-flex justify-content-md-between align-items-center">
              <div className="title d-none d-md-block">
                <h4 className="card-title align-items-center mb-3 mt-4">
                  <span className="card-label font-weight-bolder text-dark">
                    Deposit Type
                  </span>
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/ach.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(ACH)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      ACH
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/credit-card.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(Credit_Card)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      Credit Card
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/credit-card.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(Debit_Card)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      Debit Card
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          {/* <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/wire-transfer.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(Wire_Transfer)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      Wire Transfer
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div> */}
          {/* <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/echeck.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(eCheck)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      e-Check
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div> */}
        </div>
      </div>
      <div className="history-wrapper container">
        <div className="row">
          <div className="col-md-12">
            <div className="dashboard-header d-md-flex justify-content-md-between align-items-center">
              <div className="title d-none d-md-block">
                <h4 className="card-title align-items-center mb-3 mt-4">
                  <span className="card-label font-weight-bolder text-dark">
                    Commissions
                  </span>
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/ach.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(Total_ACH_commission)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      ACH
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/credit-card.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(Total_Creditcard_commission)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      Credit Card
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/credit-card.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(Total_Debitcard_commission)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      Debit Card
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
          {/* <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/wire-transfer.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(Total_wiretransfer_commission)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      Wire Transfer
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div> */}
          {/* <div className="col-md-4">
            <Card className="ard-custom card-stretch mb-5">
              <Card.Body>
                <div className="d-flex align-items-center">
                  <div className="symbol symbol-light mr-5">
                    <span className="svg-icon svg-icon-3x svg-icon-brand menu-icon mr-1">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Statistics/echeck.svg"
                        )}
                      />
                    </span>{" "}
                  </div>
                  <div className="d-flex flex-column flex-grow-1">
                    <div className="text-dark mb-0 text-hover-primary font-size-h3 font-weight-boldest cursor-pointer">
                      {amountFormatter(Total_eCheck_commission)}
                    </div>
                    <span className="text-secondary fs-13 font-weight-bold">
                      e-Check
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div> */}
        </div>
      </div>
    </>
  );
}
